/**
 * ExplanationBox — the "Untuk [Nama Anak]" AI explanation card.
 *
 * Wraps the generateExplanation() output in a soft purple card with
 * a heading + body text. Pure presentation — the actual generation
 * happens in lib/explanation.ts.
 */

import { StyleSheet, Text, View } from 'react-native';

import { Brand, Radii, Spacing } from '@/constants/theme';

interface ExplanationBoxProps {
  childName: string;
  explanation: string;
}

export function ExplanationBox({ childName, explanation }: ExplanationBoxProps) {
  return (
    <View
      style={styles.card}
      accessibilityRole="text"
      accessibilityLabel={`Penjelasan worksheet untuk ${childName}: ${explanation}`}
    >
      <Text style={styles.eyebrow}>Untuk {childName}</Text>
      <Text style={styles.body}>{explanation}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: 'rgba(86, 63, 122, 0.06)',
    borderWidth: 1,
    borderColor: 'rgba(86, 63, 122, 0.20)',
    borderRadius: Radii.medium,
    padding: Spacing.three,
    gap: Spacing.two,
  },
  eyebrow: {
    fontSize: 13,
    fontWeight: '600',
    color: Brand.primary,
  },
  body: {
    fontSize: 14,
    lineHeight: 22,
    color: '#1A0B5C',
  },
});
